import React, { useCallback } from 'react'
import { string, func } from 'prop-types'
import { useController } from 'react-hook-form'

import Checkbox from '@groovehq/internal-design-system/lib/components/Checkbox/Checkbox'
import {
  text,
  list,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { moneyString } from 'util/currency'
import { styles as mainStyles } from 'components/integrations/ShopifyV2WidgetCard/styles'

import AdditinalInfo from './AdditinalInfo/AdditinalInfo'
import RefundAmount from './RefundAmount/RefundAmount'

import { styles as orderSummaryStyles } from '../OrderSummary/styles'
import { styles } from './RefundSummary.styles'

const RefundSummary = ({
  control,
  register,
  onSubmitable,
  className,
  refundTotal,
  currencyCode,
  onShippingChange,
  onUserRefundAmountChange,
}) => {
  const {
    field: { value: refundEntity },
  } = useController({
    name: 'refundEntity',
    control,
  })
  const {
    field: { value: calculating },
  } = useController({
    name: 'isCalculating',
    control,
  })
  const isCalculating = calculating

  const item = useCallback(
    (type, value) => {
      const convertedValue = moneyString({ currencyCode, amount: value })
      return (
        <li>
          <span css={text.styles.textMediumDark}>{type}</span>
          <span css={mainStyles.moneyString}>
            {isCalculating ? 'Calculating...' : convertedValue}
          </span>
        </li>
      )
    },
    [currencyCode, isCalculating]
  )
  return (
    <div>
      <div
        className={`grui flex justify-between ${className}`}
        css={orderSummaryStyles.row}
      >
        <div>
          <p
            css={[paragraph.styles.preflight, text.styles.textMediumDark]}
            className="grui mb-5"
          >
            Refunded items will be removed from the order.
          </p>
          <Checkbox id="restock" {...register('restock')}>
            Restock item
          </Checkbox>
        </div>
        <div className="grui text-right mr-12">
          <ul
            className="grui pb-12 mb-11"
            css={[
              list.styles.preflight,
              orderSummaryStyles.summary,
              styles.summary,
              isCalculating ? styles.isCalculating : '',
            ]}
          >
            {item('Items subtotal', refundEntity.subtotal)}
            {item('Tax (included)', refundEntity.taxes)}
            {refundEntity.maximumRefundableShipping > 0
              ? item('Shipping', refundEntity.shipping)
              : null}
            {item('Refund total', refundEntity.total)}
          </ul>
        </div>
      </div>
      <div className="grui flex justify-between" css={orderSummaryStyles.row}>
        <AdditinalInfo
          currencyCode={currencyCode}
          onShippingChange={onShippingChange}
          register={register}
          maxShippingValue={refundEntity.maximumRefundableShipping}
          isCalculating={isCalculating}
        />
        <RefundAmount
          className="grui mr-12"
          currencyCode={currencyCode}
          refundTotal={refundTotal}
          onSubmitable={onSubmitable}
          register={register}
          refundEntity={refundEntity}
          onUserRefundAmountChange={onUserRefundAmountChange}
          isCalculating={isCalculating}
        />
      </div>
    </div>
  )
}

RefundSummary.propTypes = {
  currencyCode: string,
  onSubmitable: func,
  className: string,
}

RefundSummary.defaultProps = {
  currencyCode: '',
  summary: {},
  calculating: false,
  onSubmitable() {},
  className: undefined,
}

export default RefundSummary
